import React from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import CardGamePage from "../CardGame/CardGamePage";

function DijonCardGame(props) {
  return (
    <div id="cardgame-card">
      <DijonCard
        width={"90vw"}
        height={"90vh"}
        defaultX={0}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={"cardgame"}
        content={
          <div style={{ height: "100%", width: "100%", overflow: "auto", position: "relative" }}>
            <CardGamePage />
          </div>
        }
      />
    </div>
  );
}

export default DijonCardGame;
